<!-- <app-header></app-header>
<router-outlet></router-outlet> -->








<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container"> 
   
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <!-- <mat-toolbar  class="topbar telative">
       <div class="row m-0 p-0 w-100">
        <div class="col">
            <a >    
                
                <button mat-icon-button (click)="snav.toggle()" (click)="WindowResize($event)" class="navBtn mt-2" value="sidebarclosed">
                    <img src="../../../assets/images/dummy_img.svg" alt="menu">
                </button>
               <span fxFlex></span>
                </a>
                
                
        </div>
           
        <div class="col logout_div mt-4" >
            <div>
                
            </div>
        </div>
       </div>
       
    </mat-toolbar> -->

    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->

    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
       
        <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches"  >
            
                <app-sidebar></app-sidebar>
               
            
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper">
                 
                <div class="page-content">
                    <app-main-header></app-main-header>
                        <router-outlet></router-outlet>
                    
                </div>       
        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>
</div>